import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { FormGroup, ControlLabel } from 'react-bootstrap'

import { GlgSelect } from 'SharedComponents'
import { mapToSelectArray } from 'Shared/helpers'

const SeasonFilterSimGolf = ({ value, onChange, seasonsOptions }) => {
  const [searchValue, setSearchValue] = useState(value)

  const seasonsSelectOptions = mapToSelectArray(seasonsOptions, { changeNone: false })
  const seasonText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.season_filter.season'))

  useEffect(() => {
    onChange('season', searchValue)
  }, [searchValue, onChange])

  useEffect(() => {
    setSearchValue(value)
  }, [value])

  const handleChange = (event) => {
    const value = event
    setSearchValue(value)
  }

  return (
    <FormGroup>
      <Row>
        <Col xs={ true }>
          <ControlLabel className='filter_label' id='filter_label'>
            { seasonText }
          </ControlLabel>
        </Col>
      </Row>
      <Row>
        <Col xs={ true }>
          <GlgSelect
            items={ seasonsSelectOptions }
            value={ searchValue }
            onChange={ handleChange }
          />
        </Col>
      </Row>
    </FormGroup>
  )
}

SeasonFilterSimGolf.propTypes = {
  seasonsOptions: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default SeasonFilterSimGolf